import { z } from "zod"

/** The texts a new store starts with, and that each message in Kommunikation can be reset to. Edited by Julo admins. */
export const DefaultServiceMessagesSchema = z.object({
  confirmationMessage: z.string().min(1),
  serviceDayReminderMessage: z.string().min(1),
  receptionConfirmationMessage: z.string().min(1),
  serviceDoneMessage: z.string().min(1),
  bikeDoneReminderMessage: z.string().min(1),
  priceProposalReminderMessage: z.string().min(1),
  addonOrderReminderMessage: z.string().min(1),
})

export type DefaultServiceMessages = z.infer<
  typeof DefaultServiceMessagesSchema
>
